import React, { useEffect, useCallback, useMemo } from 'react';
import { useFormik } from 'formik';
import {
	Grid,
  TextField,
  MenuItem,
  Button,
  Chip,
  LinearProgress,
} from '@mui/material';
import Autocomplete from '@mui/lab/Autocomplete';
import { Text } from 'shared/components';
import { useServiceCollectionByIdQuery } from './useServiceCollectionByIdQuery';
import { useNewServiceCollection } from './useNewServiceCollection';
import { useUpdateServiceCollection } from './useUpdateServiceCollection';
import { useDeleteServiceCollection } from './useDeleteServiceCollection';
import {
  useIndicatorServices,
} from 'shared/apollo';
import omit from 'lodash/omit';
import { usePorfoliosQuery } from '../ServiceCollections/queries';
import { FullWidthField } from 'shared/account/components/FormField';

const ServiceCollectionDrawer = ({ onSave, dbId, donors }) => {
  const { data: services, loading: isServicesLoading } = useIndicatorServices();

  if (isServicesLoading) {
    return <LinearProgress variant="query"/>;
  }

  return dbId
    ? <ServiceCollectionDrawerEdit {...{ onSave, dbId, services, donors }}/>
    : <ServiceCollectionDrawerNew {...{ onSave, services, donors }}/>;
};

const ServiceCollectionDrawerEdit = ({ dbId, onSave, services, donors }) => {
  const data = useServiceCollectionByIdQuery(dbId);

  if (!data) {
    return <LinearProgress variant="query"/>;
  }

  return <ServiceCollectionDrawerInner {...{ data, services, donors, onSave, dbId }}/>;
};

const ServiceCollectionDrawerNew = ({ onSave, services, donors }) => {
  return <ServiceCollectionDrawerInner data={null} dbId={null} {...{ services, donors, onSave }}/>;
};

const ServiceCollectionDrawerInner = ({ data, services, donors, onSave, dbId }) => {

//  const isMulti = !!(selected?.id && Array.isArray(selected.id))
  const isMulti = false;
  const { isLoading: isNewLoading, run: runNew } = useNewServiceCollection();
  const { isLoading: isUpdateLoading, run: runUpdate } = useUpdateServiceCollection();
  const { isLoading: isDeleteLoading, run: runDelete } = useDeleteServiceCollection();
  const { values, setFieldValue, errors, handleSubmit, ...rest } = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: dbId
      ? data
      : {
        name: '',
        description: '',
        services: [],
        donors: [],
        portfolios: [],
      },
    onSubmit: (values, {resetForm }) => {
      const func = dbId ? runUpdate : runNew;
      function handleFinish() {
        resetForm();
        onSave();
      }
      const formPayload = {
        id: dbId,
        ...omit(values, ['services', 'donors', 'portfolios']),
        serviceIds: JSON.stringify(values.services.map(({ dbId }) => dbId)),
        donorIds: JSON.stringify(values.donors.map(({ dbId }) => dbId)),
        portfolioIds: JSON.stringify(values.portfolios.map(({ dbId }) => dbId)),
      };
      func(formPayload, handleFinish);
    },
		validate: (values) => {
      const errors = {};
			if (!values.name) {
				errors.name = 'A name is required';
      }
			if (!values.description) {
				errors.description = 'A stage is required';
      }
			return errors;
    }
  });

  const donorsIds = (values?.donors||[]).map(({ dbId }) => dbId);
  const { data: portfolios, isLoading  } = usePorfoliosQuery(donorsIds);

  const handleDelete = useCallback(() => {
    runDelete({
      id: dbId
    }, onSave);
  }, []);
  const inAllServices = useCallback(name => {
    return true;
    /*
    if (!isMulti) return true
    let isIn = 0
    values.indicators.forEach(indicator => {
      if (indicator.services.filter(service => service.name === name).length > 0) isIn +=1
    })
    return (isIn === 0 || isIn === values.indicators.length)
    */
  }, []);

  useEffect(() => {
    if (dbId && data && donors) {
      ['dbId', 'name', 'description', 'services']
        .forEach(field => setFieldValue(field, data[field]));
      /*
      setFieldValue('stageId', selected.stageId)
      setFieldValue('definition', selected.definition)
      setFieldValue('guidance', selected.guidance)
      setFieldValue('benchmarkType', selected.benchmarkType)
      setFieldValue('measurementTypeId', selected.measurementTypeId)
      setFieldValue('tagList', selected.tags.map(tag => tag.tag))
      setFieldValue('servicesList', selected.services.map(se => ({ name: se.name, id: se.dbId})))
      if (selected.id) {
        setFieldValue('indicators', selected.indicators)
      }
      */
    }
  }, [dbId, data, donors]);

  const portfolioDbIds = useMemo(() => values.portfolios.map(portfolio => portfolio.dbId), [values.portfolios]);

  const filteredServices = useMemo(() => {
    return services.filter(service =>
      service.portfolios.some(portfolioId => portfolioDbIds.includes(portfolioId))
    );
  }, [services, portfolioDbIds]);

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      {(isNewLoading || isUpdateLoading || isDeleteLoading) &&
        <LinearProgress variant="query"/>}
      {dbId && ( 
        <Grid item xs={12} style={{marginTop: '10px'}}>
          <Text variant="body1">ID: <b>{dbId}</b></Text>
        </Grid>
      )}
      <FullWidthField
        label="Name"
        name="name"
        {...{ values, errors, setFieldValue }}
      />
      <FullWidthField
        label="Description"
        name="description"
        {...{ values, errors, setFieldValue }}
        multiline
      />
      {/* <Grid item xs={12}>
        <Autocomplete
          options={donors}
          value={values.donors}
          onChange={(_, value) => setFieldValue('donors', value)}
          getOptionLabel={({ name, dbId, userId, adminEmail }) => `${name} - ${adminEmail} (ID: ${dbId})`}
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label={`Donors: ${values.donors?.length} selected`}
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map(({ name, dbId }, index) => (
              <Chip color='primary' label={`${name} (ID: ${dbId})`} {...getTagProps({ index })} />
            ))
          }
          multiple
        />
      </Grid> */}
      {/* { values.donors?.length > 0 && <Grid item xs={12}>
        <Autocomplete
          options={portfolios}
          value={values.portfolios}
          onChange={(_, value) => setFieldValue('portfolios', value)}
          getOptionLabel={({ name }) => name}
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label={`Portfolios: ${values.portfolios?.length} selected`}
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map(({ name }, index) => (
              <Chip color='primary' label={name} {...getTagProps({ index })} />
            ))
          }
          multiple
        />
      </Grid> } */}
      <Grid item xs={12}>
        <Autocomplete
          options={services}
          value={values.services}
          onChange={(_, value) => setFieldValue('services', value)}
          getOptionLabel={({ name }) => name}
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label={`Impact Models: ${values.services?.length} selected`}
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map(({ name }, index) => (
              <Chip color={inAllServices(name) ? 'primary' : 'default'} label={name} {...getTagProps({ index })} />
            ))
          }
          multiple
        />
      </Grid>
      { values.portfolios?.length > 0 && filteredServices.length === 0 && (
        <Grid item xs={12}>
          <span style={{color: 'red'}}>Currently, there are no impact models associated with the selected portfolios. Once added, they will
          appear here.</span>
        </Grid>
      )}
      <Grid item xs={6} style={{marginTop: '10px'}}>
        {dbId && (
          <Button
            onClick={handleDelete}
            style={{float: 'left'}}
            disabled={isDeleteLoading}
          >
            DELETE COLLECTION
          </Button>
        )}
      </Grid>
      <Grid item xs={6} style={{marginTop: '10px'}}>
        <Button
          onClick={handleSubmit}
          style={{float: 'right'}}
          disabled={isNewLoading || isUpdateLoading}
        >
          SAVE CHANGES
        </Button>
      </Grid>
  </Grid>
  );
};

export default ServiceCollectionDrawer;
